module.exports = __webpack_public_path__ + "static/media/start.ce14b649.svg";